import { ISelectOption } from './i-select-option';

export class ProviderOrderListFilterOptions {
    public providerShops: ISelectOption[];
}
